import './form-footer-bar.scss';

import * as gzFormFooterBar from './form-footer-bar.directive.js';

export default angular.module('gazelle.components.formFooterBar', [
  'pascalprecht.translate',
  'ngMaterial',
  // Required for angular 1.6 $compile change handled in rhino core.config.js.
  // Consider moving somewhere else
  'rhino.core',
])
  .directive(gzFormFooterBar.name, gzFormFooterBar.default)
  .name;
